"use client";

import StoreLocator from "@/containers/StoreLocator";
import useFetch from "@/hooks/useFetch";
import { getShops } from "@/requests/page";
import { distanceB2NCordsInMeters } from "@/utils";
import { envs } from "@/utils/constants";
import { getS3ImageUrl } from "@/utils/routes";

import { Wrapper } from "@googlemaps/react-wrapper";
import { useMemo, useState } from "react";

// store location page
const StoreLocatorPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [clientLocation, setClientLocation] = useState<[number, number]>([
    0, 0,
  ]);
  const [distance, setDistance] = useState(0);

  const stores = useFetch(() => getShops(), {});
  const storeLocations: StoreItem[] = useMemo(
    () =>
      (stores.response || [])?.map((store) => ({
        ...store,
        lat: +(store.lat || "0") || 23.861134477486456,
        long: +(store.long || "0") || 90.3992958,
        media:
          store.media?.map((m) =>
            getS3ImageUrl(typeof m === "string" ? m : (m as any)?.path)
          ) || [],
      })),
    [stores.response]
  );

  const filteredLocations = useMemo(() => {
    return storeLocations.filter((location) => {
      let filtered = true;

      if (searchText) {
        filtered =
          location?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          location.address?.toLowerCase().includes(searchText.toLowerCase()) ||
          location.phone?.toLowerCase().includes(searchText.toLowerCase());
      }

      if (distance > 0) {
        const distanceInMeters = distanceB2NCordsInMeters(
          clientLocation[0],
          clientLocation[1],
          location.lat,
          location.long
        );

        filtered = filtered && distanceInMeters <= distance;
      }

      return filtered;
    });
  }, [searchText, distance, clientLocation, storeLocations]);

  return (
    <>
      <Wrapper apiKey={envs.mapApiKey} region="BD">
        {/* <Script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places" /> */}

        <StoreLocator />
        {/* <StoreLocatorV2 /> */}
      </Wrapper>
    </>
  );
};

export default StoreLocatorPage;
